import React, { useMemo } from 'react'
import { Box } from '@maui/elements'

const CELL_PADDING_EM = 1

export const GridCell = ({ children, ...props }) => {
  const { columns = 1, gridColumns } = props
  const pctWidth = Math.floor((columns * 1.0 / gridColumns) * 100000) / 1000
  const flexBasis = `calc(${pctWidth}% - ${CELL_PADDING_EM}em)`
  return (
    <Box
      columns={columns}
      gridColumns={gridColumns}
      flexGrow="1"
      flexShrink="1"
      flexBasis={flexBasis}
      minWidth="350px"
      margin={`0 ${CELL_PADDING_EM * 0.5}em ${CELL_PADDING_EM}em`}
      display='flex'
      flexDirection='column'
      {...props}
    >
      {children}
    </Box>
  )
}

export const GridCellTall = ({ children, ...props }) => {
  return (
    <GridCell
      flexBasis='65.75%'
      minHeight="800px"
      {...props}
    >
      {children}
    </GridCell>
  )
}

export const GridCellNested = ({ children, ...props }) => {
  return (
    <GridCell
      flexDirection='row'
      margin='0 0 1em'
      _last={{ margin: '0' }}
      {...props}
    >
      {children}
    </GridCell>
  )
}

export const GridCellNestedSmall = ({ children, ...props }) => {
  return (
    <GridCell
      flexDirection='row'
      margin='0 0 1em'
      _last={{ margin: '0' }}
      maxHeight="400px"
      {...props}
    >
      {children}
    </GridCell>
  )
}
export const Grid = ({ children, ...props }) => {
  const { columns = 3 } = props
  const cells = useMemo(() => {
    return React.Children.map(children, (child) => {
      if (child) return React.cloneElement(child, { gridColumns: columns })
    })
  }, [children, columns])

  return (
    <Box
      display='flex'
      flexDirection='row'
      flexWrap='wrap'
      margin='0 -0.5em'
      alignItems='stretch'
      flex='1'
      {...props}
    >
      {cells}
    </Box>
  )
}

Grid.Cell = GridCell

export const GridCellExpanded = ({ children, isExpanded, flexBasis, ...props }) => {
  const addFlexBasis = isExpanded && flexBasis ? { flexBasis, height: 'calc(100vh - 18em)' } : {}
  return (
    <GridCell
      {...addFlexBasis}
      {...props}
    >
      {children}
    </GridCell>
  )
}

Grid.CellExpanded = GridCellExpanded
Grid.CellTall = GridCellTall
Grid.CellNested = GridCellNested
Grid.CellNestedSmall = GridCellNestedSmall

export default Grid
